import React, {RefObject} from "react";
import {Form, FormInstance, Switch} from "antd";
import IContainerOptions from "../../../../../../model/interface/form/elementOptions/IContainerOptions";
import IFormStructureNode from "../../../../../../model/interface/form/IFormStructureNode";
import ConditionEditor from "./ConditionEditor";
import WidgetContainerEditor from "../../../widget/optionEditor/ContainerEditor";
import Title from "antd/es/typography/Title";
import IField from "../../../../../../model/interface/dataStorage/IField";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import FilterTreeBuilder from "../../../../view/settings/customFilters/FilterTreeBuilder";
import IBaseProps from "../../../../../../model/interface/IBaseProps";
import IContentType from "../../../../../../model/interface/dataStorage/IContentType";

interface IProps extends IBaseProps {
    options: IContainerOptions,
    formRef: RefObject<FormInstance>
    fieldNodes: IFormStructureNode[]
    fields: IField[]
    contentType: IContentType
}

class ContainerEditor extends React.Component<IProps> {

    render() {
        const {fields, fieldNodes, options, match, history, contentType} = this.props

        return (
            <WidgetContainerEditor {...this.props}>
                <Form.Item name={'collapsable'} label={'Možnost skrýt'} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                {options.collapsable && (
                    <div>
                        <Title level={4}><LocaleText code={'configuration.widget.container.options.collapse-conditions'}
                                                     fallback={'Podmínky skrytí'}/></Title>
                        <Form.Item name={'conditions'} noStyle={true}>
                            <ConditionEditor fields={fields} fieldNodes={fieldNodes}/>
                        </Form.Item>

                        <Form.Item name={'remoteConditions'} label={<LocaleText
                            code={'configuration.widget.container.options.remote-collapse-conditions'} fallback={'Rozšířené podmínky skrytí'}/>}>
                            <FilterTreeBuilder contentTypeFullClassName={contentType.fullClassName}
                                               originalContentTypeFullClassName={contentType.fullClassName}
                                               match={match} history={history}/>
                        </Form.Item>
                    </div>

                )}
            </WidgetContainerEditor>
        )
    }
}

export default ContainerEditor